const statusOptions = [
  { value: 'paused', label: 'Paused' },
  { value: 'deleted', label: 'Deleted' },
  { value: 'live', label: 'Live' },
];

export default statusOptions;
